import {merge, objOf} from 'ramda'
import Future from 'fluture'
import {findDefaultPortfolio,
  getPortfolioCompaniesQuery,
  getPortfolioCompaniesByRiskTypeQuery,
} from '@/store/common'
import {sequenceFuturesObject} from '@/store/future-helpers'
import {startDate, endDate} from '@/defaults'
import {getPermissionsPayload, mergePortfolios} from '@/store/util'

const addActivePortfolio = (portfoliosObj) => {
  const defaultPortfolio = findDefaultPortfolio(portfoliosObj.portfolios)

  if (defaultPortfolio) {
    const id = defaultPortfolio.portfolioId
    return Future.of(merge(portfoliosObj)(objOf('activePortfolio')({portfolioId: id})))
  }
  const id = portfoliosObj.portfolios.length > 0 ? portfoliosObj.portfolios[0].portfolioId : 0
  return Future.of(merge(portfoliosObj)(objOf('activePortfolio')({portfolioId: id})))
}

const fetchAppData = (api) =>
  sequenceFuturesObject({
    portfoliosObj: api.fetchPortfolios({
      page: 0,
      pageSize: 1000,
    })
      .map(mergePortfolios)
      .chain(addActivePortfolio),
    translations: api.fetchTranslations(),
    notifications: api.fetchNotifications({
      startDate,
      endDate,
      paging: {
        page: 0,
        pageSize: 1000,
      },
    }),
    user: api.fetchUser(),
    preferences: api.fetchPreferences(),
  })

export const fetchInitialData = () => ({api}) => {
  const payload = fetchAppData(api)
  return {
    type: 'FETCH_INITIAL_DATA',
    payload,
  }
}

export const changeActivePortfolio = (portfolioId: number) => ({api, getState}) => {
  const prevPortfolioId = getState().app.activePortfolioId
  return {
    type: 'CHANGE_ACTIVE_PORTFOLIO',
    portfolioId,
    prevPortfolioId,
  }
}

export const savePreferences = (data) => ({api}) => {
  const preferences = api.savePreferences(data)
  return {
    type: 'SAVE_USER_PREFERENCES',
    payload: preferences,
    autoRiskTracker: data.autoRiskTracker,
  }
}

export const saveLanguagePreference = (lang) => ({api, getState}) => {
  const portfolioId = getState().app.activePortfolioId
  const portfolioCompaniesQuery = getPortfolioCompaniesQuery(getState())
  const portfolioCompaniesRiskQuery = getPortfolioCompaniesByRiskTypeQuery(getState())
  let payload
  if (getState().ui.activeTab === 'portfolios') {
    payload = sequenceFuturesObject({
      companies: api.fetchPortfolioCompanies(portfolioId, portfolioCompaniesQuery, 'portfolios', lang),
      id: api.saveLanguagePreference({languageCode: lang}),
      translations: api.fetchTranslations(lang),
    })
  } else {
    payload = sequenceFuturesObject({
      companies: api.fetchPortfolioCompanies(portfolioId, portfolioCompaniesRiskQuery, 'analysis', lang),
      id: api.saveLanguagePreference({languageCode: lang}),
      translations: api.fetchTranslations(lang),
    })
  }
  return {
    type: 'SAVE_LANG_PREFERENCE',
    payload,
    language: lang,
    portfolioId,
  }
}

export const fetchHomePageUrl = () => ({api, getState}) => {
  const payload = api.getHomePageLink()

  return {
    type: 'OPEN_LINK_HERE',
    payload,
  }
}

export const resetTabDataFlags = () => ({api, getState}) => {
  return {
    type: 'RESET_TAB_DATA_FLAGS',
  }
}

export const setTabDataFlag = (tab = 'home') => ({api, getState}) => {
  return {
    type: 'SET_TAB_DATA_FLAG',
    tab,
  }
}

export const getCustomerUsers = () => ({api, getState}) => {
  const portfolioId = getState().app.activePortfolioId
  const payload = api.fetchCustomerUsers(portfolioId)
  return {
    type: 'FETCH_CUSTOMER_USERS',
    payload,
  }
}

export const modifyCustomerUsersPermissions = () => ({api, getState}) => {
  const portfolioId = getState().app.activePortfolioId
  const data = getPermissionsPayload(getState().form.data)
  const payload = api.updateCustomerUsersPermissions(portfolioId)(data)
  return {
    type: 'UPDATE_CUSTOMER_USERS_PERMISSIONS',
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/store/app/actions.js